import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  Wrapper,
  WrappedContentRow,
  ImgContainer,
  Logo,
  ContentContainer,
  ContentRow,
  ContentRowFooter,
  DetailedDiagnosisButton,
  QuickDiagnosisButton,
  HomeCareItemButton,
  SalonMenuButton,
  SublimicSiteButton,
  IconButton,
  ErrorMessage,
} from './SublimicHomePage.style';
import Placeholder from '../../../components/Placeholder';
import Image from '../../../components/ContentfulImage';
import SublimicLogo from '../../../components/SalonConsultation/assets/sublimic-logo.svg';
import { homeCareItemFilter } from '../../../utils';
import { resetDiagnosisResult } from '../../../redux/actions/diagnosisResult';
import { resetSublimicDiagnosis } from '../../../redux/actions/sublimicDiagnosis';
import { resetScalpCameraDiagnosis } from '../../../redux/actions/scalpCameraDiagnosis';

class SublimicHomePage extends React.Component {

  handleDetailedDiagnosis = () => {
    localStorage.setItem('useDiagnosis', 'yes'); // 診断ロジックに使用
    const { history } = this.props;
    this.resetDiagnosisResult();
    history.push('diagnosis');
  };
  handleQuickDiagnosis = () => {
    localStorage.setItem('useDiagnosis', 'no'); // 診断ロジックに使用
    const { history } = this.props;
    this.resetDiagnosisResult();
    history.push('diagnosis/quick-diagnosis');
  };
  handleHomeCareItem = () => {
    const { history } = this.props;
    history.push('homecare');
  };
  handleSalonMenu = () => {
    const { history } = this.props;
    history.push('salon-program');
  };
  resetDiagnosisResult = () => {
    const { resetDiagnosisResult, resetSublimicDiagnosis, resetScalpCameraDiagnosis } = this.props;
    const regex = /rediagnosis/;
    const isRediagnosis = regex.test(location.search);

    // ストレージ削除
    // console.log('ストレージ削除');
    localStorage.removeItem('storeStylistDiagnosisResults');
    localStorage.removeItem('storeUserSurveyResult');
    localStorage.removeItem('storePinCode');

    if (!isRediagnosis) {
      resetSublimicDiagnosis();
    }
    resetDiagnosisResult();
    resetScalpCameraDiagnosis();
  }

  render() {
    const { copy, locale, homeCareItemList, authSalonSettings } = this.props;
    const { hairItems, scalpItems } = homeCareItemFilter(homeCareItemList, authSalonSettings);
    const {
      heroImage,
      detailedDiagnosisCtaLabel,
      quickDiagnosisCtaLabel,
      homeCareItemCtaIcon,
      homeCareItemCtaLabel,
      salonMenuCtaIcon,
      salonMenuCtaLabel,
      sublimicSiteCtaIcon,
      sublimicSiteCta,
      settingError,
    } = copy;
    const settings = {
      currencyCode: !!(
        authSalonSettings.basicSettings &&
        authSalonSettings.basicSettings.currencyCode &&
        authSalonSettings.basicSettings.currencyCode !== ''
      ),
      homeCareHair: !!(
        hairItems &&
        hairItems.length > 0
      ),
      homeCareScalp: !!(
        scalpItems &&
        scalpItems.length > 0
      ),
      salonMenuHair: !!(
        authSalonSettings.salonMenus &&
        authSalonSettings.salonMenus.treatments &&
        authSalonSettings.salonMenus.treatments.length > 0
      ),
      salonMenuScalp: !!(
        authSalonSettings.salonMenus &&
        authSalonSettings.salonMenus.spas &&
        authSalonSettings.salonMenus.spas.length > 0
      ),
    };
    return (
      <div style={{ backgroundColor: '#fff' }}>
        <Wrapper>
          <Helmet>
            {/* footerのフルスクリーン対応 (iPhone X ~) */}
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover" />
          </Helmet>
          <ImgContainer>
            {!!heroImage ? (
              <Image src={heroImage} options={{ w: '100%', h: '100%', objectFit: 'cover', objectPosition: '50% 0' }} />
            ) : (
              <Placeholder w="100%" h="100%" />
            )}
            <Logo src={SublimicLogo} />
          </ImgContainer>
          <ContentContainer>
            <ContentRow>
              <DetailedDiagnosisButton
                onClick={this.handleDetailedDiagnosis}
                // className={ detailedDiagnosisCtaLabel ? null : 'disabled' }
                className={
                  !settings.currencyCode || !settings.salonMenuHair || !settings.salonMenuScalp || !settings.homeCareHair || !settings.homeCareScalp
                    ? 'disabled'
                    : null
                }
              >
                {detailedDiagnosisCtaLabel || <Placeholder w="100%" h="100%" />}
              </DetailedDiagnosisButton>
              <QuickDiagnosisButton
                onClick={this.handleQuickDiagnosis}
                className={
                  !settings.currencyCode || !settings.salonMenuHair || !settings.salonMenuScalp || !settings.homeCareHair || !settings.homeCareScalp
                    ? 'disabled'
                    : null
                }
              >
                {quickDiagnosisCtaLabel || <Placeholder w="100%" h="100%" />}
              </QuickDiagnosisButton>
            </ContentRow>
            {!settings.currencyCode || !settings.salonMenuHair || !settings.salonMenuScalp || !settings.homeCareHair || !settings.homeCareScalp
              ? <ErrorMessage>{settingError || <Placeholder w="300px" h="20px" />}</ErrorMessage>
              : null
            }
            <WrappedContentRow>
              <HomeCareItemButton
                onClick={this.handleHomeCareItem}
                className={!settings.currencyCode || !settings.homeCareHair && !settings.homeCareScalp ? 'disabled' : null}
              >
                {homeCareItemCtaLabel ? (
                  <React.Fragment>
                    <IconButton>
                      {!!homeCareItemCtaIcon && (
                        <Image src={homeCareItemCtaIcon} options={{ w: '100%', h: '100%', objectFit: 'contain' }} />
                      )}
                    </IconButton>
                    {homeCareItemCtaLabel}
                  </React.Fragment>
                ) : (
                  <Placeholder w="200px" h="20px" />
                )}
              </HomeCareItemButton>
              <SalonMenuButton
                onClick={this.handleSalonMenu}
                className={!settings.currencyCode || !settings.salonMenuHair && !settings.salonMenuScalp ? 'disabled' : null}
              >
                {salonMenuCtaLabel ? (
                  <React.Fragment>
                    <IconButton>
                      {!!salonMenuCtaIcon && (
                        <Image src={salonMenuCtaIcon} options={{ w: '100%', h: '100%', objectFit: 'contain' }} />
                      )}
                    </IconButton>
                    {salonMenuCtaLabel || <Placeholder w="200px" h="20px" />}
                  </React.Fragment>
                ) : (
                  <Placeholder w="200px" h="20px" />
                )}
              </SalonMenuButton>
            </WrappedContentRow>
            <ContentRowFooter>
              <SublimicSiteButton>
                {sublimicSiteCta ? (
                  <React.Fragment>
                    <a target="_blank" href={`https://www.shiseido-professional.com/${locale}${sublimicSiteCta.url}`}>
                      {sublimicSiteCta.label}
                    </a>
                    {!!sublimicSiteCtaIcon && <img src={sublimicSiteCtaIcon.file.url} alt="" />}
                  </React.Fragment>
                ) : (
                  <Placeholder w="100px" h="20px" />
                )}
              </SublimicSiteButton>
            </ContentRowFooter>
          </ContentContainer>
        </Wrapper>
      </div>
    );
  }
}

SublimicHomePage.defaultProps = {
  copy: {},
  locale: undefined,
  history: {},
  authSalonSettings: {},
};
SublimicHomePage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string,
  history: PropTypes.shape(),
  authSalonSettings: PropTypes.shape({
    homeCareItems: PropTypes.array,
    salonMenus: PropTypes.shape({
      spas: PropTypes.array,
      treatments: PropTypes.array,
    }),
  }).isRequired,
};
const mapState = state => ({
  copy: state.sublimicHome,
  locale: state.locale,
  authSalonSettings: state.authSalonSettings,
  homeCareItemList: state.homeCareItemList,
});
const mapDispatch = dispatch => ({
  resetDiagnosisResult: () => dispatch(resetDiagnosisResult()),
  resetSublimicDiagnosis: () => dispatch(resetSublimicDiagnosis()),
  resetScalpCameraDiagnosis: () => dispatch(resetScalpCameraDiagnosis()),
});
export default connect(mapState,mapDispatch)(SublimicHomePage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomePage/SublimicHomePage.js